import React from "react";

export default function MatchBadge({ score, size = "md" }) {
  if (score == null || Number.isNaN(score)) return null;
  const n = Math.max(0, Math.min(100, Math.round(score)));
  const bg = n >= 75 ? "bg-[#22c55e] text-white" : n >= 50 ? "bg-[#eab308] text-black" : "bg-[#ec4899] text-white";
  const pad = size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-[11px]";
  return (
    <span data-testid="match-badge" className={`inline-flex items-center gap-1 font-black border-2 border-black rounded-full ${pad} ${bg}`}>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
      {n}% fit
    </span>
  );
}
